"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STYLES = void 0;
const STYLES = exports.STYLES = {
  OVERLAY: {
    HEADER_CLOSE_BUTTON: 'pal-c-OverlayDefaultHeader__closeButton',
    HEADER_BACK_BUTTON: 'pal-c-OverlayDefaultHeader__backButton'
  }
};